"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Keyring", {
  enumerable: true,
  get: function () {
    return _Keyring.Keyring;
  }
});
Object.defineProperty(exports, "Ledger", {
  enumerable: true,
  get: function () {
    return _ledger.default;
  }
});
exports.default = void 0;

var _util = require("@polkadot/util");

var _Keyring = _interopRequireWildcard(require("./Keyring"));

var _ledger = _interopRequireDefault(require("./ledger"));

// Copyright 2017-2020 @polkadot/ui-keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
// eslint-disable-next-line @typescript-eslint/no-var-requires
(0, _util.detectPackage)(require('./package.json'), typeof __dirname !== 'undefined' && __dirname);
var _default = _Keyring.default;
exports.default = _default;